import OverridesAdditional from "@/components/v2/overrides/OverridesAdditional.vue";
import { defineAsyncComponent } from "vue";

export function useComponentFactory() {
  const componentRegistry = {
    ApplicationTabSLR: defineAsyncComponent(
      () => import("@/components/v2/application/ApplicationTab.vue")
    ),
    ApplicationTabLOC: defineAsyncComponent(
      () => import("@/components/v2/application/ApplicationTab.vue")
    ),
    ApplicationTabPEL: defineAsyncComponent(
      () => import("@/components/v2/application/ApplicationTab.vue")
    ),
    CreditTabLOC: defineAsyncComponent(
      () => import("@/components/v2/credit/CreditTabSLR.vue")
    ),
    CreditTabSLR: defineAsyncComponent(
      () => import("@/components/v2/credit/CreditTabSLR.vue")
    ),
    CreditTabPEL: defineAsyncComponent(
      () => import("@/components/v2/credit/CreditTabSLR.vue")
    ),
    DocumentTabSLR: defineAsyncComponent(
      () => import("@/components/v2/documents/DocumentsTab.vue")
    ),
    DocumentTabPEL: defineAsyncComponent(
      () => import("@/components/v2/documents/DocumentsTab.vue")
    ),
    DocumentTabLOC: defineAsyncComponent(
      () => import("@/components/v2/documents/DocumentsTab.vue")
    ),
    IncomeTabLOC: defineAsyncComponent(
      () => import("@/components/v2/income/IncomeTab.vue")
    ),
    IncomeTabSLR: defineAsyncComponent(
      () => import("@/components/v2/income/IncomeTab.vue")
    ),
    IncomeTabPEL: defineAsyncComponent(
      () => import("@/components/v2/income/IncomeTab.vue")
    ),
    IdentityTabLOC: defineAsyncComponent(
      () => import("@/components/v2/identity/IdentityTab.vue")
    ),
    IdentityTabSLR: defineAsyncComponent(
      () => import("@/components/v2/identity/IdentityTab.vue")
    ),
    IdentityTabPEL: defineAsyncComponent(
      () => import("@/components/v2/identity/IdentityTab.vue")
    ),
    MembershipTabLOC: defineAsyncComponent(
      () => import("@/components/v2/membership/MembershipTab.vue")
    ),
    MembershipTabSLR: defineAsyncComponent(
      () => import("@/components/v2/membership/MembershipTab.vue")
    ),
    MembershipTabPEL: defineAsyncComponent(
      () => import("@/components/v2/membership/MembershipTab.vue")
    ),
    FinalReviewTabLOC: defineAsyncComponent(
      () => import("@/components/v2/final-review/FinalReviewTab.vue")
    ),
    FinalReviewTabSLR: defineAsyncComponent(
      () => import("@/components/v2/final-review/FinalReviewTab.vue")
    ),
    FinalReviewTabPEL: defineAsyncComponent(
      () => import("@/components/v2/final-review/FinalReviewTab.vue")
    ),
    EvaluationTabLOC: defineAsyncComponent(
      () => import("@/components/v2/evaluations/EvaluationsTab.vue")
    ),
    EvaluationTabSLR: defineAsyncComponent(
      () => import("@/components/v2/evaluations/EvaluationsTab.vue")
    ),
    EvaluationTabPEL: defineAsyncComponent(
      () => import("@/components/v2/evaluations/EvaluationsTab.vue")
    ),
    EsignTabLOC: defineAsyncComponent(
      () => import("@/components/v2/esign/EsignTabLOC.vue")
    ),
    EsignTabSLR: defineAsyncComponent(
      () => import("@/components/v2/esign/EsignTabLOC.vue")
    ),
    EsignTabPEL: defineAsyncComponent(
      () => import("@/components/v2/esign/EsignTabLOC.vue")
    ),
    PricingTabPELVersionLOC: defineAsyncComponent(
      () => import("@/components/v2/pricing/PricingPELTab.vue")
    ),
    PricingTabLOC: defineAsyncComponent(
      () => import("@/components/v2/pricing/PricingLOCTab.vue")
    ),
    PricingTabPEL: defineAsyncComponent(
      () => import("@/components/v2/pricing/PricingPELTab.vue")
    ),
    PricingTabSLR: defineAsyncComponent(
      () => import("@/components/v2/pricing/PricingSLRTab.vue")
    ),
    OverridesTabLOC: defineAsyncComponent(
      () => import("@/components/v2/overrides/OverridesTab.vue")
    ),
    OverridesTabSLR: defineAsyncComponent(
      () => import("@/components/v2/overrides/OverridesTab.vue")
    ),
    OverridesTabPEL: defineAsyncComponent(
      () => import("@/components/v2/overrides/OverridesTab.vue")
    ),
    StipulationsTabLOC: defineAsyncComponent(
      () => import("@/components/v2/stipulations/StipulationsTab.vue")
    ),
    StipulationsTabSLR: defineAsyncComponent(
      () => import("@/components/v2/stipulations/StipulationsTab.vue")
    ),
    StipulationsTabPEL: defineAsyncComponent(
      () => import("@/components/v2/stipulations/StipulationsTab.vue")
    ),
    DocumentUploaded: defineAsyncComponent(
      () => import("@/components/v2/documents/DocumentsUploaded.vue")
    ),
    DocumentGenerated: defineAsyncComponent(
      () => import("@/components/v2/documents/DocumentsGenerated.vue")
    ),
    AddStipFormLOC: defineAsyncComponent(
      () =>
        import(
          "@/components/v2/stipulations/refi-loan/AddStipulationForm.vue"
        )
    ),
    AddStipFormSLR: defineAsyncComponent(
      () =>
        import("@/components/v2/stipulations/refi-loan/AddStipulationForm.vue")
    ),
    AddStipFormPEL: defineAsyncComponent(
      () =>
        import("@/components/v2/stipulations/refi-loan/AddStipulationForm.vue")
    ),
    EvaluationCreditDecisionLOC: defineAsyncComponent(
      () =>
        import("@/components/v2/evaluations/loc-evaluations/EvaluationsCreditUnionDecisionLOC.vue")
    ),
    EvaluationCreditDecisionSLR: defineAsyncComponent(
      () =>
        import(
          "@/components/v2/evaluations/refi-evaluations/EvaluationsCreditUnionDecisionRefi.vue"
        )
    ),
    OverrideReviewLOC: defineAsyncComponent(
      () =>
        import("@/components/v2/overrides/overrides-loc/OverridesReviewLOC.vue")
    ),
    OverrideReviewShared: defineAsyncComponent(
      () =>
        import(
          "@/components/v2/overrides/shared/OverridesReview.vue"
        )
    ),
    PayoffTabSLR: defineAsyncComponent(
      () => import("@/components/v2/payoff/PayoffTab.vue")
    ),
    PayoffTabLOC: defineAsyncComponent(
      () => import("@/components/v2/payoff/PayoffTab.vue")
    ),
    OverridesAdditional: defineAsyncComponent(
      () => import("@/components/v2/overrides/OverridesAdditional.vue")
    ),
  };

  const createComponent = (identifier: string) => {
    return componentRegistry[identifier] || null;
  };

  return {
    createComponent,
  };
}
